import React from "react";
import "./Payment.css";

const Payment = ({ payment, handleToggle }) => {
  const handleClick = (e) => {
    e.preventDefault();
    handleToggle(payment.id);
  };

  let paymentName = payment.paymentName;
  let paymentComplete = payment.complete;

  return (
    <div
      id={payment.id}
      key={payment.id + paymentName}
      value={payment.id}
      onClick={(e) => handleClick(e, payment.id)}
      className={paymentComplete ? "payment strike" : "payment"}
    >
      <span>{paymentName}</span>
    </div>
  );
};

export default Payment;
